module.exports = __webpack_public_path__ + "static/media/048.be57388d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/048.jpg
// module id = 343
// module chunks = 0